import { render, staticRenderFns } from "./errorModal.vue?vue&type=template&id=2e833c73&scoped=true"
import script from "./errorModal.vue?vue&type=script&lang=js"
export * from "./errorModal.vue?vue&type=script&lang=js"
import style0 from "./errorModal.vue?vue&type=style&index=0&id=2e833c73&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e833c73",
  null
  
)

export default component.exports